import { Zap, Droplets, Construction } from "lucide-react";

const FEATURES = [
  {
    icon: Zap,
    title: "Red Eléctrica",
    text:
      "Instalación eléctrica conectada y lista, con suministro seguro y estable para que comiences a construir sin esperas.",
    testid: "feature-electricity",
  },
  {
    icon: Droplets,
    title: "Drenaje y Agua",
    text:
      "Sistema completo de alcantarillado y suministro de agua potable conectado a la red municipal.",
    testid: "feature-drainage",
  },
  {
    icon: Construction,
    title: "Calles de Concreto",
    text:
      "Vialidades de concreto hidráulico de alta durabilidad, diseñadas para resistir y mantenerse libres de baches.",
    testid: "feature-streets",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="py-24 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-5">
            <span className="text-xs tracking-[0.3em] uppercase text-[#7a6f55] font-medium">
              Infraestructura completa
            </span>
            <h2 className="font-heading mt-4 text-4xl sm:text-5xl font-light tracking-tight text-[#2D2920] leading-[1.05]">
              Bienvenido a
              <br />
              <em className="italic font-extralight text-[#3E482A]">Real San José</em>.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-lg text-[#5a5340] leading-relaxed font-light">
              Real San José es el nuevo fraccionamiento residencial desarrollado
              por <span className="text-[#3E482A] font-medium">Lauburu</span>.
              Cada lote llega con todos los servicios listos: olvídate de
              trámites e instalaciones largas, aquí solo eliges tu terreno y
              comienzas a construir tu hogar.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {FEATURES.map(({ icon: Icon, title, text, testid }, i) => (
            <article
              key={title}
              data-testid={testid}
              className={`group relative bg-white border border-[#DDD8CC] p-10 md:p-12 transition-all duration-500 hover:border-[#3E482A] hover:-translate-y-1 ${
                i === 1 ? "md:translate-y-8" : ""
              }`}
            >
              <div className="w-14 h-14 rounded-full bg-[#F3F1E8] group-hover:bg-[#3E482A] flex items-center justify-center mb-8 transition-colors">
                <Icon
                  size={24}
                  className="text-[#3E482A] group-hover:text-white transition-colors"
                  strokeWidth={1.5}
                />
              </div>
              <h3 className="font-heading text-2xl sm:text-3xl font-normal text-[#2D2920] mb-4">
                {title}
              </h3>
              <p className="text-[#5a5340] leading-relaxed font-light">
                {text}
              </p>
              <div className="mt-10 pt-6 border-t border-[#DDD8CC]/70 text-xs tracking-[0.25em] uppercase text-[#7a6f55]">
                Incluido en cada lote
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
